import React from 'react';

export default function SubmitButton({
  text,
  className,
  disabled = false,
}) {
  return (
    <input
      className={`uppercase rounded-lg px-8 py-2 text-2xl font-extrabold ${
        disabled
          ? 'opacity-50 cursor-not-allowed'
          : 'cursor-pointer'
      } ${className}`}
      type="submit"
      value={disabled ? 'Submitting...' : text}
      disabled={disabled}
    />
  );
}